module.exports = __webpack_public_path__ + "img/g.edd0e34f.svg";